import type { DocumentType } from '../../graphql/generated/gql';
import { gql } from '../../graphql/generated/gql';
import { PlanInterval } from '../../graphql/generated/graphql';
import formatCurrency from '../../utils/formatCurrency';

const applyPercentCoupon = (
  value: number,
  coupon?: { percentOff?: number | null },
) => {
  const percentOff = coupon?.percentOff || 0;
  const applicable = 1 - percentOff / 100;

  return value * applicable;
};

const applyCoupon = (
  value: number,
  coupon?: DocumentType<
    typeof GET_TOTAL_FOR_INTERVAL_BILLING_COUPON_FRAGMENT
  > | null,
) => {
  if (coupon?.percentOff) return applyPercentCoupon(value, coupon);
  return Math.max(0, value);
};

const GET_TOTAL_FOR_INTERVAL_BILLING_COUPON_FRAGMENT = gql(`
  fragment getTotalForInterval_billingCoupon on BillingCoupon {
    id
    percentOff
  }
`);

export const getTotalForInterval = (
  planAmount: number,
  userCount: number,
  coupon?: DocumentType<
    typeof GET_TOTAL_FOR_INTERVAL_BILLING_COUPON_FRAGMENT
  > | null,
) => {
  const subtotal = planAmount * userCount;
  const total = applyCoupon(subtotal, coupon);

  return formatCurrency(total);
};

const GET_MONTHLY_PRICE_BILLING_COUPON_FRAGMENT = gql(`
  fragment getMonthlyPrice_billingCoupon on BillingCoupon {
    id
    percentOff
  }
`);

export const getMonthlyPrice = (
  planInterval: PlanInterval,
  planAmount: number,
  seatCount: number,
  coupon?: DocumentType<typeof GET_MONTHLY_PRICE_BILLING_COUPON_FRAGMENT>,
) => {
  const period = planInterval === PlanInterval.Yearly ? 12 : 1;
  const subtotal = planAmount * seatCount;
  const total = applyCoupon(subtotal / period, coupon);

  return formatCurrency(total);
};
